import { columnSettings } from "./report-template-setting";
import { format } from "date-fns";

const settings = {};
for (let columnSetting of columnSettings) {
  settings[columnSetting.field] = columnSetting;
}

const ReportTemplateDetail = (props) => {
  const {
    mykey,
    no,
    tanggal_transaksi,
    speedo_akhir,
    jenis_minyak,
    harga_per_liter,
    jumlah,
    total_harga,
  } = props;

  return (
    <>
      <tr
        key={mykey}
        className="row-start-start w-full text-sm text-slate-700 !items-stretch"
      >
        <td
          className={`${settings["no"].layout} ${settings["no"].width} border-zinc-300 border border-t-0  px-2 pt-2 pb-1 `}
        >
          {no}
        </td>

        <td
          className={`${settings["tanggal_transaksi"].layout} ${settings["tanggal_transaksi"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
        >
          {tanggal_transaksi
            ? format(
                new Date(tanggal_transaksi),
                settings["tanggal_transaksi"].format
              )
            : "-"}
        </td>

        <td
          className={`${settings["jenis_minyak"].layout} ${settings["jenis_minyak"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
        >
          {jenis_minyak}
        </td>

        <td
          className={`${settings["jumlah"].layout} ${settings["jumlah"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
        >
          {jumlah ? jumlah.toLocaleString("id-ID") : "-"}
        </td>

        <td
          className={`${settings["harga_per_liter"].layout} ${settings["harga_per_liter"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
        >
          {harga_per_liter ? harga_per_liter.toLocaleString("id-ID") : "-"}
        </td>

        <td
          className={`${settings["total_harga"].layout} ${settings["total_harga"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
        >
          {total_harga ? total_harga.toLocaleString("id-ID") : "-"}
        </td>

        <td
          className={`${settings["speedo_akhir"].layout} ${settings["speedo_akhir"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
        >
          {speedo_akhir ? speedo_akhir.toLocaleString("id-ID") : "-"}
        </td>
      </tr>
    </>
  );
};

export default ReportTemplateDetail;
